import {
  Text,
  Heading,
  Stack,
  Inline,
  Box,
  Column,
  Columns,
  CheckboxStandalone,
  Strong,
} from 'braid-design-system';
import { useId } from 'react';

import type { ListingProduct } from 'src/generated/graphql';

interface AddOnsProps {
  searchBoostProduct: ListingProduct;
  checked: boolean;
  onChange: () => void;
}

export const SearchBoostAddOn = (props: AddOnsProps) => {
  const checkboxId = useId();
  const labelId = useId();

  return (
    <Box data={{ testid: 'search-boost-add-on' }}>
      <Stack space="medium">
        <Heading level="4">Add-ons</Heading>

        <Columns space="xsmall">
          <Column width="content">
            <CheckboxStandalone
              id={checkboxId}
              aria-labelledby={labelId}
              data={{ testid: 'search-boost-checkbox' }}
              checked={props.checked}
              onChange={props.onChange}
              size="small"
            />
          </Column>

          <Column>
            <Stack space="small">
              <Box
                component="label"
                cursor="pointer"
                htmlFor={checkboxId}
                id={labelId}
                userSelect="none"
              >
                <Inline alignY="center" space="small">
                  <Text weight="strong">Search Boost</Text>

                  <Inline alignY="bottom" space="xxsmall">
                    <Text weight="strong">
                      ${props.searchBoostProduct.cost / 100}
                    </Text>
                    <Text size="small" weight="strong">
                      + GST
                    </Text>
                  </Inline>
                </Inline>
              </Box>

              <Text
                tone="secondary"
                size="small"
                data={{ testid: 'search-boost-description' }}
              >
                Your ad is featured at the top of relevant search results pages.
                Boosted ads <Strong>on average receive 50%</Strong> more
                enquiries.
              </Text>
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
};
